import {
  formatArtifactDate,
  formatArtifactType,
  getOwnerProfile
} from "../collaborationUtils";

export const formatArtifactDateCompact = value => {
  if (!value) {
    return null;
  }

  const parts = String(value).split("-");
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${Number(day)}.${month}.${year}`;
  }

  return formatArtifactDate(value);
};

const firstName = fullName => {
  const name = String(fullName || "").trim();
  if (!name) {
    return null;
  }
  return name.split(/\s+/)[0];
};

export const buildParticipantsKicker = (blocks, workspaceTitle, owner) => {
  const ownerProfile = getOwnerProfile(owner);
  const partnerNames = [];
  let trackCodeName = ownerProfile.name;

  const walk = nodes => {
    (nodes || []).forEach(node => {
      if (node.type === "contacthead" && node.content?.name) {
        const company = String(node.content.co || "").toLowerCase();
        const name = firstName(node.content.name);
        if (!name) {
          return;
        }
        if (company.includes("trackcode")) {
          trackCodeName = name;
        } else {
          partnerNames.push(name);
        }
      }
      if (node.children?.length) {
        walk(node.children);
      }
    });
  };

  walk(blocks);

  const uniquePartnerNames = [...new Set(partnerNames)];
  const partnerPart = uniquePartnerNames.length
    ? `${workspaceTitle}: ${uniquePartnerNames.join(", ")}`
    : workspaceTitle;
  const trackCodePart = trackCodeName
    ? `TrackCode: ${trackCodeName}`
    : "TrackCode";

  return `${partnerPart} · ${trackCodePart}`;
};

export const buildArtifactKickerMeta = ({ artifact, workspace, blocks }) => ({
  typeLabel: formatArtifactType(artifact?.type),
  participants: buildParticipantsKicker(
    blocks,
    workspace?.title || "Partner",
    artifact?.owner
  ),
  location: artifact?.location,
  date: formatArtifactDateCompact(artifact?.date),
  title: artifact?.title,
  lead: artifact?.lead
});
